import { Button } from '@interco/inter-ui/components/Button'
import { FlexColumn } from '@interco/inter-ui/components/Flex'
import { Text } from '@interco/inter-ui/components/Text'
import { interWbNavigate } from '@interco/inter-webview-bridge'

export const UnsupportedFakeDoor = () => (
  <FlexColumn className="p-6" gap="16px" justifyContent="space-between" height="100vh">
    <FlexColumn gap="8px">
      <Text variant="headline-h2" as="h1" semiBold>
        Fake Door
      </Text>
      <Text variant="body-2" as="p" colorWeight={500}>
        Tipo de fake door não suportado.
      </Text>
    </FlexColumn>

    <Button fullWidth onClick={() => interWbNavigate.requestGoBack()}>
      Voltar
    </Button>
  </FlexColumn>
)
